export default {
  postStatus: {
    draft: "草稿",
    published: "发布",
    recycled: "垃圾",
  },
  postType: {
    AR: "AR资讯",
    HEALTH: "健康资讯",
  },
  sex: {
    male: "男",
    female: "女",
    unknown: "未知",
  },
  statementType: {
    income: "收入",
    consume: "支出",
  },
  capitalOrderStatus: {
    None: "冻结中",
    Completed: "已完成",
    Canceled: "已退单",
  },
  goodsTypes: [
    { name: "话费充值", value: "TelephoneCharge" },
    { name: "油卡充值", value: "OilCardCharge" },
    { name: "本地生活", value: "LocalCater" },
    { name: "电商产品", value: "Eshop" },
    { name: "点餐产品", value: "Mahua" },
  ],
};
